export default function IconA2() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1215_7545)">
                <path
                    d="M24.75 12.375C24.9427 12.3903 26.2531 12.3555 26.4375 12.375C29.8125 12.375 31.5 15.1704 31.5 17.4375C31.5 18.5625 30.9375 20.8125 29.1756 22.1329C28.9822 22.2574 27.7721 22.3798 27.5625 22.5"
                    stroke="#707070"
                    strokeWidth="1.35"
                />
                <path
                    d="M10.9932 12.375C9.99316 12.375 8.49316 12.375 6.49316 12.375C6.80475 13.0589 8.21947 16.1219 9.00041 16.3125"
                    stroke="#707070"
                    strokeWidth="1.35"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 3.375C18.3107 3.375 18.5919 3.50093 18.7955 3.70454C18.9991 3.90812 19.125 4.18935 19.125 4.5C19.125 4.81065 18.9991 5.09188 18.7955 5.29546C18.5919 5.49907 18.3107 5.625 18 5.625C17.6893 5.625 17.4081 5.49907 17.2045 5.29546C17.0009 5.09188 16.875 4.81065 16.875 4.5C16.875 4.18935 17.0009 3.90812 17.2045 3.70454C17.4081 3.50093 17.6893 3.375 18 3.375Z"
                    stroke="#707070"
                    strokeWidth="1.35"
                />
                <path
                    d="M27.9569 29.1735C27.9706 29.0343 27.9835 28.8946 27.9955 28.7544C28.0807 27.7644 28.125 26.7488 28.125 25.7138C28.125 20.7955 27.1254 16.3145 25.4859 12.9447C23.6341 9.13859 20.966 6.75 18 6.75C15.0219 6.75 12.3441 9.15822 10.4914 12.9917C8.8654 16.3561 7.875 20.8183 7.875 25.7138C7.875 26.7693 7.92104 27.8047 8.00957 28.8132C8.0224 28.9594 8.03612 29.105 8.05072 29.25"
                    stroke="#707070"
                    strokeWidth="1.35"
                />
                <path d="M11.25 12.375H25.875" stroke="#707070" strokeWidth="1.35" />
                <path d="M16.875 25.875H19.125" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" />
                <rect x="6.3" y="28.8" width="23.4" height="3.15" rx="1.575" stroke="#707070" strokeWidth="1.35" />
            </g>
            <defs>
                <clipPath id="clip0_1215_7545">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
